import { render, staticRenderFns } from "./index.vue?vue&type=template&id=845c5b08&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=845c5b08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845c5b08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('845c5b08')) {
      api.createRecord('845c5b08', component.options)
    } else {
      api.reload('845c5b08', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=845c5b08&scoped=true&", function () {
      api.rerender('845c5b08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/slxc/index.vue"
export default component.exports